import React from 'react'
import { Box, Stack, Button, Divider } from '@mui/material';
import { FieldArray, Form, Formik } from "formik";
import { useSnackbar } from 'notistack';
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import * as fileApi from '../../../lib/api/file';
import { listProjectFiles } from '../../../modules/techModule/projectFiles';
import ProjectMultiFileForm from '../../../components/techmng/files/ProjectMultiFileForm';
import ChanceFileList from '../../../components/chancemng/files/ChanceFileList';




const validationSchema = yup.object().shape({
    files: yup.array().of(
        yup.object().shape({
            fileAttrVal2: yup.string().required('파일 타입을 선택하세요'),
            fileDesc: yup.string().nullable('비고를 입력하세요'),
            file: yup.mixed().required('파일을 선택하세요'),
        })
    )
});



const ProjectMultiFileFormContainer = () => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    // const { project } = useSelector(({ techModule, chanceModule }) => ({

    //     if(techModule.project.project){
            
    //         project: techModule.project.project,
    //     }else{
    //         project: chanceModule.chance.chance,
    //     }
    // }));

    const { project } = useSelector(({ techModule, chanceModule }) => ({
        project: techModule.project.project || chanceModule.chance.chance
    }));

    const onSave = async (value) => {

        let formData = new FormData();
        formData.append('fileDt', value.file);
        formData.append('fileTyp', 'project');
        formData.append('fileAttrVal1', project.prjUuid);
        formData.append('fileAttrVal2', value.fileAttrVal2);
        formData.append('fileDesc', value.fileDesc);
        //console.log(formData, 'formData');
// FormData 내용 확인
console.log('FormData contents:----------------------------------------------------------------');
for (let [key, value] of formData.entries()) {
    console.log(key, value);
}
console.log('----------------------------------------------------------------');
        try {
            const response = await fileApi.addFiles(formData);
            if (response.data) {
                dispatch(listProjectFiles('project', project.prjUuid));
            }
        } catch (err) {
            let message =
                typeof err.response !== 'undefined'
                    ? err.response.data.message
                    : err.message;
            enqueueSnackbar(message, {
                variant: 'error',
            });
        }
    };

    return (
        <Box sx={{ my: 1 }}>


            <Formik
                initialValues={{
                    files: [{
                        fileAttrVal2: '',
                        fileDesc: '',
                        file: null
                    }]
                }}
                validationSchema={validationSchema}
                onSubmit={async (values, { resetForm }) => {
                    if (values.files.length > 0) {
                        values.files.map((value) => {
                            onSave(value);
                        })
                        resetForm();
                    }


                }}
            >
                {({ isSubmitting, values, touched, errors, handleChange, handleBlur, isValid }) => (
                    <Form noValidate autoComplete="off">
                        <FieldArray name="files">
                            {({ insert, remove, push }) => (
                                <Box>

                                    <Box>
                                        {values.files.map((f, index) => {
                                            return (
                                                <ProjectMultiFileForm
                                                    key={index}
                                                    file={f}
                                                    index={index}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    handleRemove={() => remove(index)} />
                                            )
                                        })}
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 1 }}>
                                    <Button sx={{ mx: 2 }} color="secondary" variant="outlined" 
                                        onClick={() => push({ fileAttrVal2: '', fileDesc: '', file: null })}>파일 추가</Button>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            variant="contained"
                                            disabled={!isValid || values.files.length === 0 || isSubmitting}
                                        >
                                            저장
                                        </Button>
                                    </Box>
                                </Box>
                            )}
                        </FieldArray>

                    </Form>
                )}
            </Formik>

        </Box>
    )
}

export default ProjectMultiFileFormContainer